/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nav_available_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Available Tools`)
};

const es_nav_available_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas disponibles`)
};

const de_nav_available_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbare Werkzeuge`)
};

const nl_nav_available_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschikbare tools`)
};

const fr_nav_available_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outils disponibles`)
};

const it_nav_available_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strumenti disponibili`)
};

const pt_br2_nav_available_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas disponíveis`)
};

const pt_nav_available_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas disponíveis`)
};

const ja_nav_available_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用可能なツール`)
};

const zh_nav_available_tools = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可用工具`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nav_available_tools = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nav_available_tools(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nav_available_tools", locale)
	if (locale === "en") return en_nav_available_tools(inputs)
	if (locale === "es") return es_nav_available_tools(inputs)
	if (locale === "de") return de_nav_available_tools(inputs)
	if (locale === "nl") return nl_nav_available_tools(inputs)
	if (locale === "fr") return fr_nav_available_tools(inputs)
	if (locale === "it") return it_nav_available_tools(inputs)
	if (locale === "pt-BR") return pt_br2_nav_available_tools(inputs)
	if (locale === "pt") return pt_nav_available_tools(inputs)
	if (locale === "ja") return ja_nav_available_tools(inputs)
	return zh_nav_available_tools(inputs)
};